import store from '../store';
import swal from 'sweetalert2';
import Translation from '@/services/Translation';

const needAuth = auth => auth === true;

const beforeEach = (to, from, next) => {
    store.dispatch('checkSystemLocale').then(() => {
        const auth = !to.meta.hasOwnProperty('forVisitors') || true !== to.meta.forVisitors;
        const ability = to.meta.hasOwnProperty('requiredAbility') ? to.meta.requiredAbility : null;
        const confirmation = from.meta.hasOwnProperty('leaveConfirmation') ? from.meta.leaveConfirmation : false;
        const submit = from.meta.hasOwnProperty('submit') ? from.meta.submit : false;

        store.dispatch('resetMessages');

        // Make sure moment locale is set
        // TODO better place for this? locale is not yet available in main.js
        if (moment.locale() !== store.state.system_locale) {
            moment.locale(store.state.system_locale);
        }

        if (confirmation && !submit) {
            swal({
                type: 'warning',
                title: Translation.get('messages.confirmation.are_you_sure', null, store.state.system_locale),
                text: Translation.get('messages.confirmation.leave', null, store.state.system_locale),
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: Translation.get('messages.confirmation.yes_leave', null, store.state.system_locale),
                cancelButtonText: Translation.get('messages.confirmation.no_stay', null, store.state.system_locale)
            }).then((result) => {
                next(!!result.value);
            });
            return;
        }
        if (from.meta.hasOwnProperty('submit') && submit) {
            from.meta.submit = false;
        }

        if (!needAuth(auth)) {
            next();
        } else {
            const search = window.location.search;

            store.dispatch('checkUserAvailable').then(() => {
                store.dispatch('loadSidebarLogoUrl');
                store.dispatch('loadIsGlobalManagementSystem');
                store.dispatch('loadHasClOnlyFeatures');
                store.dispatch('loadPasswordResetEnabled');

                let intendedPath = sessionStorage.getItem('intended_path');

                if (intendedPath) {
                    sessionStorage.removeItem('intended_path');
                }

                if (ability) {
                    store.dispatch('checkRouteAbility', ability).then(() => {
                        intendedPath ? next({path: intendedPath}) : next();
                    }).catch(() => {
                        next({path: `/dashboard`});
                        store.dispatch('swalToast', {
                            type: 'error',
                            message: Translation.get('exceptions.authorization_page', null, store.state.system_locale)
                        });
                    });
                } else {
                    intendedPath ? next({path: intendedPath}) : next();
                }
            }).catch(() => {
                let intendedPath = `${to.path}?`;

                // Add route query to url - cut first '&'
                if (search) {
                    intendedPath = `${intendedPath}${search.substring(1)}`;
                }

                sessionStorage.setItem('intended_path', intendedPath);
            });
        }
    });
};

export default beforeEach;



// WEBPACK FOOTER //
// ./src/router/beforeEach.js